import PropTypes from 'prop-types';
import React from 'react';
import {
  TYPE_KAPHA,
  TYPE_PITTA,
  TYPE_VATA,
} from '../../data/types';
import styles from '../../styles/main.scss';

const SummaryComponent = (props) => (
  <div>
    <h2 className="h2-alt">
      Резултати от аюрведичния доша тест
    </h2>
    <div className="offset-bottom">
      <p>
        Доша тестът е завършен. Съотношението на вашата доша е посочено по-долу в текста
      </p>
      <p>
        {
          Object.entries(props.answersStatistics)
            .sort((a, b) => b[1] - a[1])
            .map(([type, value], index) => {
              const percentage = ((value / props.questionCount) * 100).toFixed(1);
              let typeLabel = '-';

              if (type === TYPE_KAPHA) {
                typeLabel = 'кафа';
              } else if (type === TYPE_PITTA) {
                typeLabel = 'питта';
              } else if (type === TYPE_VATA) {
                typeLabel = 'вата';
              }

              return (
                <span
                  className={styles[`dos${index + 1}`]}
                  key={type}
                >
                  {typeLabel}: {percentage}%<br />
                </span>
              );
            })
        }
      </p>
      <p>
        Всяко човешко същество се ражда с уникална пропорция от трите жизнени ергии <em>(доша - вата, питта и кафа)</em>, които са съставени от петте елемента на природата <em>(етер, въздух, огън, вода, земя)</em>. Вата е комбинация от въздух и етер, Пита представлява огън и вода, а Кафа - вода и земя. С течение на живота пропорциите на дошите се отклоняват (викрити) от първоначалното им състояние <em>(пракрити)</em>.
      </p>
      <p>
        Ако тестът установи, че Пита е вашата доминираща характеристика, тогава вие сте тип Пита. В случай, че имате две доши, които са еднакво представени, тогава вие сте комбиниран тип. Все пак и в този случай една от дошите преобладава и следователно ще има по-голямо влияние върху вашия дисбаланс. Балансираният тип Вата-Пита-Кафа е много рядко срещан.
      </p>
      <p>
        Препоръки за възстановяване на баланса при всеки тип:
      </p>

    </div>
    <button
      className="btn btn-default"
      onClick={props.onResetClick}
    >
      Направете теста отново
    </button>
  </div>
);

SummaryComponent.propTypes = {
  answersStatistics: PropTypes.shape({}).isRequired,
  onResetClick: PropTypes.func.isRequired,
  questionCount: PropTypes.number.isRequired,
};

export default SummaryComponent;
